import React, { useMemo } from 'react'
import Button from 'react-bootstrap/Button';
import Modal from 'react-bootstrap/Modal';


const SweetAlert = ({ show, onHide, title, subtitle, icon, confirmButtonText, cancelButtonText, showCancelButton, onConfirm, onCancel, loadSubmit, content, iconClassName, modalSize, addCustomButtons, customButtons }) => {
    const showIcon = useMemo(() => {
        let iconClass = ''
        if (icon === 'delete') {
            iconClass = 'fa fa-trash text-danger'
        } else if (icon === 'shopping') {
            iconClass = 'fa fa-shopping-cart text-success'
        } else if (icon === 'approve') {
            iconClass = 'fa fa-check text-success'
        } else if (icon === 'info') {
            iconClass = 'fa fa-check text-success'
        } else if (icon === 'question') {
            iconClass = 'fa fa-question text-info'
        }

        if (iconClassName) {
            iconClass = iconClassName
        }

        return iconClass === '' ? '' : <i className={iconClass + ' fa-5x mt-4 mb-4'}></i>
    }, [icon, iconClassName])

    const renderButtons = useMemo(() => {
        let buttons = ''

        if (icon === 'delete') {
            buttons = <>
                <Button variant={`danger ${showCancelButton ? ' mr-2' : ''}`} onClick={onConfirm} disabled={loadSubmit}>
                    {loadSubmit ? <i className="fa fa-circle-notch fa-spin"></i> : confirmButtonText}
                </Button>
                {showCancelButton ? <Button variant="dark" onClick={onCancel} disabled={loadSubmit}>{cancelButtonText}</Button> : ''}
            </>
        } else if (icon === 'approve') {
            buttons = <>
                <Button variant={`success ${showCancelButton ? ' mr-2' : ''}`} onClick={onConfirm} disabled={loadSubmit}>
                    {loadSubmit ? <i className="fa fa-circle-notch fa-spin"></i> : confirmButtonText}
                </Button>
                {showCancelButton ? <Button variant="dark" onClick={onCancel} disabled={loadSubmit}>{cancelButtonText}</Button> : ''}
            </>
        } else if (icon === 'shopping') {
            buttons = <>
                {showCancelButton ? <Button variant="outline-dark mr-2" onClick={onCancel} disabled={loadSubmit}>{cancelButtonText}</Button> : ''}
                <Button variant={`success ${showCancelButton ? ' mr-2' : ''}`} onClick={onConfirm} disabled={loadSubmit}>
                    {loadSubmit ? <i className="fa fa-circle-notch fa-spin"></i> : confirmButtonText}
                </Button>
            </>
        } else if (icon === 'info') {
            buttons = <>
                {showCancelButton ? <Button variant="info mr-2" onClick={onCancel} disabled={loadSubmit}>{cancelButtonText}</Button> : ''}
                {/* <Button variant={`success ${showCancelButton ? ' mr-2' : ''}`} onClick={onConfirm}>
                    {loadSubmit ? <i className="fa fa-circle-notch fa-spin"></i> : confirmButtonText}
                </Button> */}
            </>
        } else if (icon === 'question') {
            buttons = <>
                <Button variant={`success ${showCancelButton ? ' mr-2' : ''}`} onClick={onConfirm} disabled={loadSubmit}>
                    {loadSubmit ? <i className="fa fa-circle-notch fa-spin"></i> : confirmButtonText}
                </Button>
                {showCancelButton ? <Button variant="dark" onClick={onCancel} disabled={loadSubmit}>{cancelButtonText}</Button> : ''}
            </>
        }

        return addCustomButtons ? customButtons() : buttons
    }, [icon, loadSubmit, showCancelButton, onConfirm, confirmButtonText, onCancel, cancelButtonText])

    return <Modal show={show} onHide={onHide} backdrop="static" centered size={modalSize}>
        <Modal.Body className="text-center">
            {showIcon}

            <h3><strong>{title}</strong></h3>
            <p>{subtitle}</p>
            {content()}
            <div className="mt-4">
                {renderButtons}
            </div>
        </Modal.Body>
    </Modal>
}

SweetAlert.defaultProps = {
    title: '',
    subtitle: '',
    icon: '',
    show: false,
    onHide: () => { },
    onConfirm: () => { },
    confirmButtonText: '',
    onCancel: () => { },
    cancelButtonText: '',
    showCancelButton: true,
    loadSubmit: false,
    content: _ => { },
    iconClassName: '',
    modalSize: '',
    addCustomButtons: false,
    customButtons: () => { },
}

export default SweetAlert;